<template>
	<router-view/>
</template>

<script>


export default {
	name: 'App',
    created() {
        this.$i18n.locale = this.$store.getters['locale/LOCALE'];
    }
}
</script>

<style>
</style>
